export const queryFilterOfLandingsList: any = () => {
  let filter = {
    query: {
      operands: [
        [
          {
            name: "Status",
            condition: "notinlist",
            value: ["DELETED", "INACTIVE"]
          }
        ]
      ]
    },
    from: 1,
    to: 150
  }
  return filter
}
export const queryFilterOfQuizList: any = () => {
  let filter = {
    query: {
      operands: [
        [
          {
            name: "Status",
            condition: "notinlist",
            value: ["DELETED", "INACTIVE"]
          }
        ]
      ]
    },
    from: 1,
    to: 150
  }
  return filter
}